import { config } from "@/config";
import type { IInsuranceApprovedEstimate } from "@/interfaces/analytics";
import { Provider } from "@/providers/http.provider";

interface IGetApprovedEstimatesParams {
  organizationId?: string;
}

interface IGetApprovedEstimatesResponse {
  success: boolean;
  data: {
    estimates: IInsuranceApprovedEstimate[];
  };
  error?: string;
}

class AnalyticsProvider extends Provider {
  constructor() {
    super({
      baseURL: `${config.baseAPIUrl}/rest/valueadd/`,
    });
  }

  async getApprovedEstimates(params: IGetApprovedEstimatesParams = {}): Promise<IGetApprovedEstimatesResponse> {
    try {
      const { organizationId } = params;

      const queryParams = new URLSearchParams();

      if (organizationId) {
        queryParams.append("organizationId", organizationId);
      }

      const url = `analytics${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;

      const response = await super.get<IGetApprovedEstimatesResponse>(url);

      if (!response.success) {
        throw new Error(response.error || "Unable to fetch approved estimates");
      }

      return response;
    } catch (error) {
      console.error("Get approved estimates failed:", error);
      throw new Error("Get approved estimates failed");
    }
  }
}

export default new AnalyticsProvider();
